import React from 'react';
import { Check, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import { SEND_STEPS } from '../constants';
import type { SendWizardStep } from '../types';

interface SendStepperProps {
  currentStep: SendWizardStep;
}

export const SendStepper: React.FC<SendStepperProps> = ({ currentStep }) => (
  <nav aria-label="Etapas do envio" className="flex w-full items-center py-5">
    <ol className="flex flex-wrap items-center gap-3">
      {SEND_STEPS.map((item, index) => {
        const isActive = item.step === currentStep;
        const isCompleted = item.step < currentStep;
        const isHighlighted = isActive || isCompleted;

        return (
          <React.Fragment key={item.step}>
            <li className="flex items-center gap-2">
              <span
                className={cn(
                  'inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-medium leading-4',
                  isCompleted && 'bg-[#F2FF00] p-1.5 text-black',
                  isActive && 'bg-[#171717] p-0.5 text-[#FAFAFA]',
                  !isHighlighted &&
                    'border border-[#E5E5E5] bg-white p-0.5 text-[#737373]'
                )}
              >
                {isCompleted ? (
                  <Check className="h-5 w-5" strokeWidth={2} aria-hidden />
                ) : (
                  item.step
                )}
              </span>
              <span
                className={cn(
                  'text-base font-normal leading-6',
                  isHighlighted ? 'text-[#0A0A0A]' : 'text-[#737373]'
                )}
              >
                {item.label}
              </span>
            </li>
            {index < SEND_STEPS.length - 1 ? (
              <li className="flex items-center" aria-hidden>
                <ChevronRight
                  className="h-5 w-5 shrink-0 text-[#D1D5DB]"
                  strokeWidth={2}
                />
              </li>
            ) : null}
          </React.Fragment>
        );
      })}
    </ol>
  </nav>
);
